import tableOperation from '../common/table-operation'

const getPaginatedPhoneNumbers = function (state) {
  const { limit, currentPage, searchText = "" } = state.table

  const result = tableOperation.getPaginatedCollection({
    collection: [...state.phoneNumbers],
    paginationConfig: {
      limit: limit,
      page: currentPage,
      query: searchText,
    },
  })

  return result
}

export default getPaginatedPhoneNumbers
